/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, CSSProperties, useContext, useState, } from "react";
import cn from "./helpers/cn";

interface RadioGroupContextProps {
  name?: string;
  value?: any;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: any) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const RadioGroupContext = createContext<RadioGroupContextProps | undefined>(undefined);

export const useRadioGroup = (): any => useContext(RadioGroupContext);

interface RadioGroupProps {
  children: React.ReactNode;
  name?: string;
  value?: string | null;
  defaultValue?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  row?: boolean;
  className?: string;
  id?: string;
  style?: CSSProperties;
}

const RadioGroup = ({
  children,
  name,
  value,
  defaultValue,
  onChange,
  onBlur,
  row,
  className,
  style,
  id
}: RadioGroupProps): JSX.Element => {
  const [internalValue, setInternalValue] = useState(defaultValue);

  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    if (!isControlled) {
      setInternalValue(newValue);
    }
    if (onChange) {
      onChange(event, newValue);
    }
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(event);
    }
  };

  return (
    <RadioGroupContext.Provider value={{ name, value: currentValue, onChange: handleChange, onBlur: handleBlur }}>
      <div id={id} role="radiogroup" style={style} className={cn("flex flex-wrap", row ? "flex-row gap-4" : "flex-col gap-2", className)}>
        {children}
      </div>
    </RadioGroupContext.Provider>
  );
};

RadioGroup.displayName = "RadioGroup";

export default RadioGroup;